// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalRightOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalRightOutlined";
import AntdIcon from '../components/AntdIcon';

var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalRightOutlinedSvg
  }));
};

VerticalRightOutlined.displayName = 'VerticalRightOutlined';
export default React.forwardRef(VerticalRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/VerticalRightOutlined.js
// module id = 2029
// module chunks = 0